import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  makeStyles,
  Grid,
  Typography,
} from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import {
  AdditionalEvidenceRequest,
  StatementsOfAssuranceRequest,
} from "../../../../../domain/AdditionalEvidenceRequest";
import { Error } from "../../../../common/Error";
import { AttachmentList } from "../../../AttachmentList";
import { Attachment } from "../../../../../domain/Attachment";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
  body: {
    marginTop: 5,
    marginBottom: 5,
  },
}));

type OtherEvidenceProps = {
  request: AdditionalEvidenceRequest;
  onClick: (entity: StatementsOfAssuranceRequest | "other" | null) => void;
  onSave: (data: { files: File[]; otherEvidenceResponseText: string }) => void;
  onDownload: (blobId: string) => Promise<Blob>;
  onDeleteAttachment: (attachment: Attachment) => void;
};

export const OtherEvidence: React.FC<OtherEvidenceProps> = ({
  onClick,
  request,
  onSave,
  onDownload,
  onDeleteAttachment,
}) => {
  const classes = useStyles();

  const { handleSubmit, control, errors } = useForm({
    defaultValues: {
      files: [],
      otherEvidenceResponseText: request.otherEvidenceResponseText || "",
    },
  });

  return (
    <>
      <DialogTitle data-test="additional-evidence-title">
        Other evidence
        <Divider />
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
              {request.otherEvidenceText}
            </Typography>
          </Grid>
        </Grid>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="otherEvidenceResponseText"
                rules={{ required: true }}
                as={
                  <TextField
                    data-test="other-evidence-response-text"
                    multiline
                    rows={5}
                    label="Other evidence"
                    required
                  />
                }
              />
              {errors.otherEvidenceResponseText && (
                <Error>This field is required</Error>
              )}
            </Grid>
            {request.allowAttachments ? (
              <>
                <Grid item xs={12}>
                  <Controller
                    control={control}
                    name="files"
                    as={<FileInput multiple={true} />}
                  />
                  {request.attachments && request.attachments.length ? (
                    <AttachmentList
                      canEdit={true}
                      attachments={request.attachments}
                      getBlob={onDownload}
                      deleteAttachment={onDeleteAttachment}
                    />
                  ) : null}
                </Grid>
              </>
            ) : null}
          </Grid>
        </form>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={() => onClick(null)}
          color="primary"
          data-test="back-additional-evidence-button"
        >
          Back
        </Button>
        <Button
          onClick={handleSubmit(onSave)}
          color="primary"
          data-test="save-additional-evidence-button"
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
};
